import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container", "overlay", "destroyInput", "buttonText"]

  toggleDelete() {
    const isMarkedForDeletion = this.destroyInputTarget.value === "1"
    
    if (isMarkedForDeletion) {
      // Unmark for deletion
      this.destroyInputTarget.value = "0"
      this.containerTarget.classList.remove("opacity-50")
      this.containerTarget.style.display = ""
      if (this.hasOverlayTarget) {
        this.overlayTarget.classList.remove("flex")
        this.overlayTarget.classList.add("hidden")
      }
      if (this.hasButtonTextTarget) this.buttonTextTarget.textContent = "Ištrinti"
    } else {
      // Mark for deletion
      this.destroyInputTarget.value = "1"
      this.containerTarget.classList.add("opacity-50")
      if (this.hasOverlayTarget) {
        this.overlayTarget.classList.remove("hidden")
        this.overlayTarget.classList.add("flex")
      } else {
        this.containerTarget.style.display = "none"
      }
      if (this.hasButtonTextTarget) this.buttonTextTarget.textContent = "Atšaukti"
      this.notifyDefaultMemoryRowRemoved()
    }
  }

  notifyDefaultMemoryRowRemoved() {
    const memoryKeys = Array.from(
      this.element.querySelectorAll("[data-lookup-selector-memory-key-value]")
    ).map((element) => element.dataset.lookupSelectorMemoryKeyValue).filter(Boolean)

    document.dispatchEvent(new CustomEvent("default-memory:row-removed", {
      detail: { memoryKeys }
    }))
  }
}
